import { render, staticRenderFns } from "./CreatingLessonAssignmentFolderModal.vue?vue&type=template&id=7c227a7a&scoped=true&"
import script from "./CreatingLessonAssignmentFolderModal.vue?vue&type=script&lang=ts&"
export * from "./CreatingLessonAssignmentFolderModal.vue?vue&type=script&lang=ts&"
import style0 from "./CreatingLessonAssignmentFolderModal.vue?vue&type=style&index=0&id=7c227a7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c227a7a",
  null
  
)

export default component.exports